export default {
  secretary: [
    {
      name: "داشبورد",
      url: "/secretary/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "ثبت استعلام جدید",
      url: "/secretary/newOrder",
      icon: "fa fa-plus",
      open: false,
    },
    {
      name: "جستجو",
      url: "/secretary/search",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "قوانین صدور استعلام",
      url: "/secretary/rules",
      icon: "fa fa-legal",
      open: false,
    },
    {
      name: "الگوهای سازمانی",
      url: "/secretary/templates",
      icon: "fa fa-map",
      open: false,
    },
    {
      name: "استعلام‌های فعال",
      url: "/secretary/activeOrders",
      icon: "fa fa-envelope-open",
      open: false,
    },
    {
      name: "استعلام‌های فعال ویژه",
      url: "/secretary/activeVipOrders",
      icon: "fa fa-heart-o",
      open: false,
    },
    {
      name: "استعلام‌های آماده ارسال به کارخانه",
      url: "/secretary/orderstoproducts",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "آرشیو استعلام‌ها",
      url: "/secretary/orders",
      icon: "fa fa-list",
      open: false,
    },
    {
      name: "به تفکیک وضعیت",
      url: "#",
      icon: "fa fa-list",
      open: false,
      badge: {
        variant: "primary",
        text: "جدید",
      },
      children: [
        {
          name: "ثبت استعلام",
          url: "/secretary/ordersPerStatus/1",
          icon: "fa fa-gear",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار بررسی فنی",
          url: "/secretary/ordersPerStatus/2",
          icon: "fa fa-gears",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تعیین قیمت توسط مدیر عامل",
          url: "/secretary/ordersPerStatus/3",
          icon: "fa fa-dollar",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بررسی تعیین قیمت توسط مدیر فروش",
          url: "/secretary/ordersPerStatus/4",
          icon: "fa fa-money",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده برای امضا",
          url: "/secretary/ordersPerStatus/5",
          icon: "fa fa-pencil-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "اعلام تعیین قیمت به مشتری",
          url: "/secretary/ordersPerStatus/6",
          icon: "fa fa-bullhorn",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار نظر مشتری",
          url: "/secretary/ordersPerStatus/7",
          icon: "fa fa-clock-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تایید تعیین قیمت توسط مشتری",
          url: "/secretary/ordersPerStatus/8",
          icon: "fa fa-check-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "رد تعیین قیمت توسط مشتری",
          url: "/secretary/ordersPerStatus/9",
          icon: "fa fa-times-rectangle-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "عدم",
          url: "/secretary/ordersPerStatus/10",
          icon: "fa fa-deaf",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آرشیو",
          url: "/secretary/ordersPerStatus/11",
          icon: "fa fa-archive",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بازبینی تعیین قیمت",
          url: "/secretary/ordersPerStatus/12",
          icon: "fa fa-spinner",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده ارسال به کارخانه",
          url: "/secretary/ordersPerStatus/13",
          icon: "fa fa-thumbs-o-up",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "ارسال به کارخانه",
          url: "/secretary/ordersPerStatus/14",
          icon: "fa fa-send-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
      ],
    },
    {
      name: "مدیریت مشتری‌ها",
      url: "/secretary/customerManagement",
      icon: "fa fa-users",
      open: false,
    },
    {
      name: "پیگیری سفارش‌های کارخانه",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "آرشیو سفارش‌های کارخانه",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/secretary/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/secretary/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  secretaryStatus: [
    {
      name: "داشبورد",
      url: "/secretaryStatus/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "ثبت استعلام جدید",
      url: "/secretaryStatus/newOrder",
      icon: "fa fa-plus",
      open: false,
    },
    {
      name: "جستجو",
      url: "/secretaryStatus/search",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "قوانین صدور استعلام",
      url: "/secretaryStatus/rules",
      icon: "fa fa-legal",
      open: false,
    },
    {
      name: "الگوهای سازمانی",
      url: "/secretaryStatus/templates",
      icon: "fa fa-map",
      open: false,
    },
    {
      name: "استعلام‌های فعال",
      url: "/secretaryStatus/activeOrders",
      icon: "fa fa-envelope-open",
      open: false,
    },
    {
      name: "استعلام‌های فعال ویژه",
      url: "/secretaryStatus/activeVipOrders",
      icon: "fa fa-heart-o",
      open: false,
    },
    {
      name: "استعلام‌های آماده ارسال به کارخانه",
      url: "/secretaryStatus/orderstoproducts",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "آرشیو استعلام‌ها",
      url: "/secretaryStatus/orders",
      icon: "fa fa-list",
      open: false,
    },
    {
      name: "به تفکیک وضعیت",
      url: "#",
      icon: "fa fa-list",
      open: false,
      badge: {
        variant: "primary",
        text: "جدید",
      },
      children: [
        {
          name: "ثبت استعلام",
          url: "/secretaryStatus/ordersPerStatus/1",
          icon: "fa fa-gear",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار بررسی فنی",
          url: "/secretaryStatus/ordersPerStatus/2",
          icon: "fa fa-gears",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تعیین قیمت توسط مدیر عامل",
          url: "/secretaryStatus/ordersPerStatus/3",
          icon: "fa fa-dollar",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بررسی تعیین قیمت توسط مدیر فروش",
          url: "/secretaryStatus/ordersPerStatus/4",
          icon: "fa fa-money",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده برای امضا",
          url: "/secretaryStatus/ordersPerStatus/5",
          icon: "fa fa-pencil-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "اعلام تعیین قیمت به مشتری",
          url: "/secretaryStatus/ordersPerStatus/6",
          icon: "fa fa-bullhorn",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار نظر مشتری",
          url: "/secretaryStatus/ordersPerStatus/7",
          icon: "fa fa-clock-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تایید تعیین قیمت توسط مشتری",
          url: "/secretaryStatus/ordersPerStatus/8",
          icon: "fa fa-check-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "رد تعیین قیمت توسط مشتری",
          url: "/secretaryStatus/ordersPerStatus/9",
          icon: "fa fa-times-rectangle-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "عدم",
          url: "/secretaryStatus/ordersPerStatus/10",
          icon: "fa fa-deaf",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آرشیو",
          url: "/secretaryStatus/ordersPerStatus/11",
          icon: "fa fa-archive",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بازبینی تعیین قیمت",
          url: "/secretaryStatus/ordersPerStatus/12",
          icon: "fa fa-spinner",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده ارسال به کارخانه",
          url: "/secretaryStatus/ordersPerStatus/13",
          icon: "fa fa-thumbs-o-up",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "ارسال به کارخانه",
          url: "/secretaryStatus/ordersPerStatus/14",
          icon: "fa fa-send-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
      ],
    },
    {
      name: "مدیریت مشتری‌ها",
      url: "/secretaryStatus/customerManagement",
      icon: "fa fa-users",
      open: false,
    },
    {
      name: "پیگیری سفارش‌های کارخانه",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "آرشیو سفارش‌های کارخانه",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/secretaryStatus/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/secretaryStatus/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  trade: [
    {
      name: "داشبورد",
      url: "/trade/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "جستجو",
      url: "/trade/search",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "استعلام‌های فعال",
      url: "/trade/activeOrders",
      icon: "fa fa-envelope-open",
      open: false,
    },
    {
      name: "استعلام‌های فعال ویژه",
      url: "/trade/activeVipOrders",
      icon: "fa fa-heart-o",
      open: false,
    },
    {
      name: "جستجوی محصولات انبار",
      url: "/warehouse/productsSearch",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "جستجوی دقیق محصولات",
      url: "/warehouse/productsExactSearch",
      icon: "fa fa-search-plus",
      open: false,
    },
    {
      name: "استعلام‌های آماده ارسال به کارخانه",
      url: "/trade/orderstoproducts",
      icon: "fa fa-check-square",
      open: false,
      badge: {
        variant: "warning",
        text: "",
      },
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "آرشیو استعلام‌ها",
      url: "/trade/orders",
      icon: "fa fa-list",
      open: false,
    },
    {
      name: "آرشیو سفارش‌ها",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "به تفکیک وضعیت",
      url: "#",
      icon: "fa fa-list",
      open: false,
      // badge: {
      //   variant: "primary",
      //   text: "جدید",
      // },
      children: [
        {
          name: "ثبت استعلام",
          url: "/trade/ordersPerStatus/1",
          icon: "fa fa-gear",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار بررسی فنی",
          url: "/trade/ordersPerStatus/2",
          icon: "fa fa-gears",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تعیین قیمت توسط مدیر عامل",
          url: "/trade/ordersPerStatus/3",
          icon: "fa fa-dollar",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بررسی تعیین قیمت توسط مدیر فروش",
          url: "/trade/ordersPerStatus/4",
          icon: "fa fa-money",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده برای امضا",
          url: "/trade/ordersPerStatus/5",
          icon: "fa fa-pencil-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "اعلام تعیین قیمت به مشتری",
          url: "/trade/ordersPerStatus/6",
          icon: "fa fa-bullhorn",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار نظر مشتری",
          url: "/trade/ordersPerStatus/7",
          icon: "fa fa-clock-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تایید تعیین قیمت توسط مشتری",
          url: "/trade/ordersPerStatus/8",
          icon: "fa fa-check-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "رد تعیین قیمت توسط مشتری",
          url: "/trade/ordersPerStatus/9",
          icon: "fa fa-times-rectangle-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "عدم",
          url: "/trade/ordersPerStatus/10",
          icon: "fa fa-deaf",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آرشیو",
          url: "/trade/ordersPerStatus/11",
          icon: "fa fa-archive",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بازبینی تعیین قیمت",
          url: "/trade/ordersPerStatus/12",
          icon: "fa fa-spinner",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده ارسال به کارخانه",
          url: "/trade/ordersPerStatus/13",
          icon: "fa fa-thumbs-o-up",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "ارسال به کارخانه",
          url: "/trade/ordersPerStatus/14",
          icon: "fa fa-send-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
      ],
    },
    {
      name: "قوانین صدور استعلام",
      url: "/trade/rules",
      icon: "fa fa-legal",
      open: false,
    },
    {
      name: "الگوهای سازمانی",
      url: "/trade/templates",
      icon: "fa fa-map",
      open: false,
    },
    {
      name: "مدیریت مشتری‌ها",
      url: "/trade/customerManagement",
      icon: "fa fa-users",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/trade/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/trade/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  tradeIntern: [
    {
      name: "داشبورد",
      url: "/tradeIntern/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "ثبت استعلام",
      url: "/tradeIntern/ordersPerStatus/1",
      icon: "fa fa-gear",
      open: false,
      badge: {
        variant: "success",
        text: "",
      },
    },
    {
      name: "ارسال به کارخانه",
      url: "/tradeIntern/ordersPerStatus/14",
      icon: "fa fa-send-o",
      open: false,
      badge: {
        variant: "success",
        text: "",
      },
    },
    {
      name: "قوانین صدور استعلام",
      url: "/tradeIntern/rules",
      icon: "fa fa-legal",
      open: false,
    },
    {
      name: "الگوهای سازمانی",
      url: "/tradeIntern/templates",
      icon: "fa fa-map",
      open: false,
    },
    {
      name: "مدیریت مشتری‌ها",
      url: "/tradeIntern/customerManagement",
      icon: "fa fa-users",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/tradeIntern/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/tradeIntern/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  salesManager: [
    {
      name: "داشبورد",
      url: "/salesManager/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "جستجو",
      url: "/salesManager/search",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "منابع انسانی",
      // url: "#",
      icon: "fa fa-address-book",
      open: false,
      children: [
        {
          name: "گزارش",
          url: "/hrm/reports",
          icon: "fa fa-line-chart",
          open: false,
        },
      ],
    },
    {
      name: "سفارش سریع",
      url: "/salesManager/newFastOrder",
      icon: "fa fa-bolt",
      open: false,
    },
    {
      name: "استعلام‌های فعال",
      url: "/salesManager/activeOrders",
      icon: "fa fa-envelope-open",
      open: false,
    },
    {
      name: "استعلام‌های فعال ویژه",
      url: "/salesManager/activeVipOrders",
      icon: "fa fa-heart-o",
      open: false,
    },
    {
      name: "استعلام‌های آماده ارسال به کارخانه",
      url: "/salesManager/orderstoproducts",
      icon: "fa fa-check-square",
      open: false,
      badge: {
        variant: "warning",
        text: "",
      },
    },
    {
      name: "کارخانه",
      url: "#",
      icon: "fa fa-list",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "آرشیو سفارش‌ها",
          url: "/factory/ordersArchive",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "جستجوی محصولات انبار",
          url: "/warehouse/productsSearch",
          icon: "fa fa-search",
          open: false,
        },
        {
          name: "جستجوی دقیق محصولات",
          url: "/warehouse/productsExactSearch",
          icon: "fa fa-search-plus",
          open: false,
        },
      ],
    },
    {
      name: "آرشیو استعلام‌ها",
      url: "/salesManager/orders",
      icon: "fa fa-list",
      open: false,
    },
    {
      name: "به تفکیک وضعیت",
      url: "#",
      icon: "fa fa-list",
      open: false,
      badge: {
        variant: "primary",
        text: "جدید",
      },
      children: [
        {
          name: "ثبت استعلام",
          url: "/salesManager/ordersPerStatus/1",
          icon: "fa fa-gear",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار بررسی فنی",
          url: "/salesManager/ordersPerStatus/2",
          icon: "fa fa-gears",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تعیین قیمت توسط مدیر عامل",
          url: "/salesManager/ordersPerStatus/3",
          icon: "fa fa-dollar",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بررسی تعیین قیمت توسط مدیر فروش",
          url: "/salesManager/ordersPerStatus/4",
          icon: "fa fa-money",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده برای امضا",
          url: "/salesManager/ordersPerStatus/5",
          icon: "fa fa-pencil-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "اعلام تعیین قیمت به مشتری",
          url: "/salesManager/ordersPerStatus/6",
          icon: "fa fa-bullhorn",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار نظر مشتری",
          url: "/salesManager/ordersPerStatus/7",
          icon: "fa fa-clock-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تایید تعیین قیمت توسط مشتری",
          url: "/salesManager/ordersPerStatus/8",
          icon: "fa fa-check-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "رد تعیین قیمت توسط مشتری",
          url: "/salesManager/ordersPerStatus/9",
          icon: "fa fa-times-rectangle-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "عدم",
          url: "/salesManager/ordersPerStatus/10",
          icon: "fa fa-deaf",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آرشیو",
          url: "/salesManager/ordersPerStatus/11",
          icon: "fa fa-archive",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بازبینی تعیین قیمت",
          url: "/salesManager/ordersPerStatus/12",
          icon: "fa fa-spinner",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده ارسال به کارخانه",
          url: "/salesManager/ordersPerStatus/13",
          icon: "fa fa-thumbs-o-up",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "ارسال به کارخانه",
          url: "/salesManager/ordersPerStatus/14",
          icon: "fa fa-send-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
      ],
    },
    {
      name: "قوانین صدور استعلام",
      url: "/salesManager/rules",
      icon: "fa fa-legal",
      open: false,
    },
    {
      name: "الگوهای سازمانی",
      url: "/salesManager/templates",
      icon: "fa fa-map",
      open: false,
    },
    {
      name: "مدیریت مشتری‌ها",
      url: "/salesManager/customerManagement",
      icon: "fa fa-users",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/salesManager/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "گزارش‌ها",
      // url: "#",
      icon: "fa fa-line-chart",
      open: false,
      open: false,
      children: [
        {
          name: "گزارش فروش",
          url: "/salesManager/salesReports",
          icon: "fa fa-bar-chart",
          open: false,
        },
        {
          name: "یک نگاه",
          url: "/salesManager/reports",
          icon: "fa fa-line-chart",
          open: false,
        },
      ],
    },
    {
      name: "تغییر رمزعبور",
      url: "/salesManager/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  tradeHead: [
    {
      name: "داشبورد",
      url: "/tradeHead/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "جستجو",
      url: "/tradeHead/search",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "استعلام‌های فعال",
      url: "/tradeHead/activeOrders",
      icon: "fa fa-envelope-open",
      open: false,
    },
    {
      name: "استعلام‌های فعال ویژه",
      url: "/tradeHead/activeVipOrders",
      icon: "fa fa-heart-o",
      open: false,
    },
    {
      name: "جستجوی محصولات انبار",
      url: "/warehouse/productsSearch",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "جستجوی دقیق محصولات",
      url: "/warehouse/productsExactSearch",
      icon: "fa fa-search-plus",
      open: false,
    },
    {
      name: "استعلام‌های آماده ارسال به کارخانه",
      url: "/tradeHead/orderstoproducts",
      icon: "fa fa-check-square",
      open: false,
      badge: {
        variant: "warning",
        text: "",
      },
    },
    {
      name: "آرشیو استعلام‌ها",
      url: "/tradeHead/orders",
      icon: "fa fa-list",
      open: false,
    },
    {
      name: "به تفکیک وضعیت",
      url: "#",
      icon: "fa fa-list",
      open: false,
      badge: {
        variant: "primary",
        text: "جدید",
      },
      children: [
        {
          name: "ثبت استعلام",
          url: "/tradeHead/ordersPerStatus/1",
          icon: "fa fa-gear",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار بررسی فنی",
          url: "/tradeHead/ordersPerStatus/2",
          icon: "fa fa-gears",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تعیین قیمت توسط مدیر عامل",
          url: "/tradeHead/ordersPerStatus/3",
          icon: "fa fa-dollar",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بررسی تعیین قیمت توسط مدیر فروش",
          url: "/tradeHead/ordersPerStatus/4",
          icon: "fa fa-money",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده برای امضا",
          url: "/tradeHead/ordersPerStatus/5",
          icon: "fa fa-pencil-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "اعلام تعیین قیمت به مشتری",
          url: "/tradeHead/ordersPerStatus/6",
          icon: "fa fa-bullhorn",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار نظر مشتری",
          url: "/tradeHead/ordersPerStatus/7",
          icon: "fa fa-clock-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تایید تعیین قیمت توسط مشتری",
          url: "/tradeHead/ordersPerStatus/8",
          icon: "fa fa-check-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "رد تعیین قیمت توسط مشتری",
          url: "/tradeHead/ordersPerStatus/9",
          icon: "fa fa-times-rectangle-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "عدم",
          url: "/tradeHead/ordersPerStatus/10",
          icon: "fa fa-deaf",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آرشیو",
          url: "/tradeHead/ordersPerStatus/11",
          icon: "fa fa-archive",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بازبینی تعیین قیمت",
          url: "/tradeHead/ordersPerStatus/12",
          icon: "fa fa-spinner",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده ارسال به کارخانه",
          url: "/tradeHead/ordersPerStatus/13",
          icon: "fa fa-thumbs-o-up",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "ارسال به کارخانه",
          url: "/tradeHead/ordersPerStatus/14",
          icon: "fa fa-send-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
      ],
    },
    {
      name: "قوانین صدور استعلام",
      url: "/tradeHead/rules",
      icon: "fa fa-legal",
      open: false,
    },
    {
      name: "الگوهای سازمانی",
      url: "/tradeHead/templates",
      icon: "fa fa-map",
      open: false,
    },
    {
      name: "مدیریت مشتری‌ها",
      url: "/tradeHead/customerManagement",
      icon: "fa fa-users",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/tradeHead/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/tradeHead/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  queryOrganizer: [
    {
      name: "تایید تعیین قیمت توسط مشتری",
      url: "/queryOrganizer/ordersPerStatus/8",
      icon: "fa fa-check-square-o",
      open: false,
      badge: {
        variant: "success",
        text: "",
      },
    },
    {
      name: "قوانین صدور استعلام",
      url: "/queryOrganizer/rules",
      icon: "fa fa-legal",
      open: false,
    },
    {
      name: "الگوهای سازمانی",
      url: "/queryOrganizer/templates",
      icon: "fa fa-map",
      open: false,
    },
    {
      name: "جستجوی محصولات انبار",
      url: "/warehouse/productsSearch",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "جستجوی دقیق محصولات",
      url: "/warehouse/productsExactSearch",
      icon: "fa fa-search-plus",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/queryOrganizer/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/queryOrganizer/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  accountant: [
    {
      name: "داشبورد",
      url: "/accountant/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "به تفکیک وضعیت",
      url: "#",
      icon: "fa fa-list",
      open: false,
      badge: {
        variant: "primary",
        text: "جدید",
      },
      children: [
        {
          name: "ثبت استعلام",
          url: "/accountant/ordersPerStatus/1",
          icon: "fa fa-gear",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار بررسی فنی",
          url: "/accountant/ordersPerStatus/2",
          icon: "fa fa-gears",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تعیین قیمت توسط مدیر عامل",
          url: "/accountant/ordersPerStatus/3",
          icon: "fa fa-dollar",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بررسی تعیین قیمت توسط مدیر فروش",
          url: "/accountant/ordersPerStatus/4",
          icon: "fa fa-money",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده برای امضا",
          url: "/accountant/ordersPerStatus/5",
          icon: "fa fa-pencil-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "اعلام تعیین قیمت به مشتری",
          url: "/accountant/ordersPerStatus/6",
          icon: "fa fa-bullhorn",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "در انتظار نظر مشتری",
          url: "/accountant/ordersPerStatus/7",
          icon: "fa fa-clock-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "تایید تعیین قیمت توسط مشتری",
          url: "/accountant/ordersPerStatus/8",
          icon: "fa fa-check-square-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "رد تعیین قیمت توسط مشتری",
          url: "/accountant/ordersPerStatus/9",
          icon: "fa fa-times-rectangle-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "عدم",
          url: "/accountant/ordersPerStatus/10",
          icon: "fa fa-deaf",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آرشیو",
          url: "/accountant/ordersPerStatus/11",
          icon: "fa fa-archive",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "بازبینی تعیین قیمت",
          url: "/accountant/ordersPerStatus/12",
          icon: "fa fa-spinner",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "آماده ارسال به کارخانه",
          url: "/accountant/ordersPerStatus/13",
          icon: "fa fa-thumbs-o-up",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
        {
          name: "ارسال به کارخانه",
          url: "/accountant/ordersPerStatus/14",
          icon: "fa fa-send-o",
          open: false,
          badge: {
            variant: "success",
            text: "",
          },
        },
      ],
    },
    {
      name: "مدیریت مشتری‌ها",
      url: "/accountant/customerManagement",
      icon: "fa fa-users",
      open: false,
    },
    {
      name: "پیگیری سفارش‌های کارخانه",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "آرشیو سفارش‌های کارخانه",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/accountant/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/accountant/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  ceo: [
    {
      name: "داشبورد",
      url: "/ceo/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "جستجو",
      url: "/ceo/search",
      icon: "fa fa-search",
      open: false,
    },

    {
      name: "دبیرخانه",
      url: "/ceo/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },

    {
      name: "دفتر مرکزی",
      // url: "#",
      icon: "fa fa-list",
      open: false,
      children: [
        {
          name: "استعلام‌های فعال",
          url: "/ceo/activeOrders",
          icon: "fa fa-envelope-open",
          open: false,
        },
        {
          name: "استعلام‌های فعال ویژه",
          url: "/ceo/activeVipOrders",
          icon: "fa fa-heart-o",
          open: false,
        },
        {
          name: "استعلام‌های آماده ارسال به کارخانه",
          url: "/ceo/orderstoproducts",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "آرشیو استعلام‌ها",
          url: "/ceo/orders",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "به تفکیک وضعیت",
          url: "#",
          icon: "fa fa-list",
          open: false,
          badge: {
            variant: "primary",
            text: "جدید",
          },
          children: [
            {
              name: "ثبت استعلام",
              url: "/ceo/ordersPerStatus/1",
              icon: "fa fa-gear",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "در انتظار بررسی فنی",
              url: "/ceo/ordersPerStatus/2",
              icon: "fa fa-gears",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "تعیین قیمت توسط مدیر عامل",
              url: "/ceo/ordersPerStatus/3",
              icon: "fa fa-dollar",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "بررسی تعیین قیمت توسط مدیر فروش",
              url: "/ceo/ordersPerStatus/4",
              icon: "fa fa-money",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "آماده برای امضا",
              url: "/ceo/ordersPerStatus/5",
              icon: "fa fa-pencil-square-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "اعلام تعیین قیمت به مشتری",
              url: "/ceo/ordersPerStatus/6",
              icon: "fa fa-bullhorn",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "در انتظار نظر مشتری",
              url: "/ceo/ordersPerStatus/7",
              icon: "fa fa-clock-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "تایید تعیین قیمت توسط مشتری",
              url: "/ceo/ordersPerStatus/8",
              icon: "fa fa-check-square-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "رد تعیین قیمت توسط مشتری",
              url: "/ceo/ordersPerStatus/9",
              icon: "fa fa-times-rectangle-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "عدم",
              url: "/ceo/ordersPerStatus/10",
              icon: "fa fa-deaf",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "آرشیو",
              url: "/ceo/ordersPerStatus/11",
              icon: "fa fa-archive",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "بازبینی تعیین قیمت",
              url: "/ceo/ordersPerStatus/12",
              icon: "fa fa-spinner",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "آماده ارسال به کارخانه",
              url: "/ceo/ordersPerStatus/13",
              icon: "fa fa-thumbs-o-up",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "ارسال به کارخانه",
              url: "/ceo/ordersPerStatus/14",
              icon: "fa fa-send-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
          ],
        },
        {
          name: "مدیریت مشتری‌ها",
          url: "/ceo/customerManagement",
          icon: "fa fa-users",
          open: false,
        },
      ],
    },

    {
      name: "کارخانه",
      // url: "#",
      icon: "fa fa-list",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "آرشیو سفارش‌ها",
          url: "/factory/ordersArchive",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "اقلام در حال تولید",
          url: "/factory/productionItemsPerStatus",
          icon: "fa fa-gear",
          open: false,
        },
        {
          name: "فرآیند تولید",
          url: "/factory/productionProcess",
          icon: "fa fa-chain",
          open: false,
        },
        {
          name: "اقلام به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "مشاهده اقلام به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
          children: [
            {
              name: "بررسی اولیه",
              url: "/factory/orderItemsPerStatusId/1",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "توقف موقت تولید",
              url: "/factory/orderItemsPerStatusId/2",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله تامین مواد اولیه",
              url: "/factory/orderItemsPerStatusId/3",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله تولید",
              url: "/factory/orderItemsPerStatusId/4",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله تامین",
              url: "/factory/orderItemsPerStatusId/5",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "موجود در انبار",
              url: "/factory/orderItemsPerStatusId/6",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله پوشش کاری",
              url: "/factory/orderItemsPerStatusId/7",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "اتمام تولید",
              url: "/factory/orderItemsPerStatusId/8",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله ارسال",
              url: "/factory/orderItemsPerStatusId/9",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله بسته بندی",
              url: "/factory/orderItemsPerStatusId/10",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "لغو سفارش",
              url: "/factory/orderItemsPerStatusId/11",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "تحویل نهایی",
              url: "/factory/orderItemsPerStatusId/12",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت تولید",
              url: "/factory/orderItemsPerStatusId/13",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش گالوانیزه گرم",
              url: "/factory/orderItemsPerStatusId/14",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش تفلون",
              url: "/factory/orderItemsPerStatusId/15",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش سرامیک",
              url: "/factory/orderItemsPerStatusId/16",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش زایلون",
              url: "/factory/orderItemsPerStatusId/17",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش گالوانیزه سرد",
              url: "/factory/orderItemsPerStatusId/18",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش داک",
              url: "/factory/orderItemsPerStatusId/19",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت خدمات فورجینگ",
              url: "/factory/orderItemsPerStatusId/20",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت سختکاری",
              url: "/factory/orderItemsPerStatusId/21",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در انتظار صدور نقشه فنی",
              url: "/factory/orderItemsPerStatusId/22",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در انتظار تایید نقشه فنی",
              url: "/factory/orderItemsPerStatusId/23",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در انتظار خرید خدمت",
              url: "/factory/orderItemsPerStatusId/24",
              icon: "fa fa-list",
              open: false,
            },
          ],
        },
      ],
    },

    {
      name: "فروشگاه",
      url: "/shop/dashboard",
      icon: "fa fa-list",
      open: false,
    },

    {
      name: "مدیریت انبارها",
      url: "#",
      icon: "fa fa-database",
      open: false,
      children: [
        // {
        //   name: "لیست انبارها",
        //   url: "/warehouse/allWarehouses",
        //   icon: "fa fa-check-square"
        // },
        {
          name: "محصولات",
          url: "/warehouse/productsWarehouses",
          open: false,
          icon: "fa fa-archive",
        },
        {
          name: "مواد اولیه",
          url: "/warehouse/materialsWarehouses",
          open: false,
          icon: "fa fa-archive",
        },
        // {
        //   name: "ملزومات",
        //   url: "/warehouse/toolsWarehouses",
        //   icon: "fa fa-archive"
        // }
      ],
    },
    {
      name: "مدیریت اقلام",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "محصولات",
          url: "/warehouse/products",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "جستجوی محصولات",
          url: "/warehouse/productsSearch",
          icon: "fa fa-search",
          open: false,
        },
        {
          name: "جستجوی دقیق محصولات",
          url: "/warehouse/productsExactSearch",
          icon: "fa fa-search-plus",
          open: false,
        },
        {
          name: "مواد اولیه",
          url: "/warehouse/materials",
          icon: "fa fa-archive",
          open: false,
        },
        // {
        //   name: "ملزومات",
        //   url: "/warehouse/tools",
        //   icon: "fa fa-archive"
        // }
      ],
    },

    {
      name: "تنظیمات",
      // url: "#",
      icon: "fa fa-list",
      open: false,
      open: false,
      children: [
        {
          name: "قوانین صدور استعلام",
          url: "/ceo/rules",
          icon: "fa fa-legal",
          open: false,
        },
        {
          name: "الگوهای سازمانی",
          url: "/ceo/templates",
          icon: "fa fa-map",
          open: false,
        },
        {
          name: "تغییر رمزعبور",
          url: "/ceo/changePassword",
          icon: "fa fa-lock",
          open: false,
        },
      ],
    },
    {
      name: "گزارش‌ها",
      // url: "#",
      icon: "fa fa-line-chart",
      open: false,
      open: false,
      children: [
        {
          name: "یک نگاه",
          url: "/ceo/reports",
          icon: "fa fa-line-chart",
          open: false,
        },
        {
          name: "گزارش فروش",
          url: "/ceo/salesReports",
          icon: "fa fa-bar-chart",
          open: false,
        },
      ],
    },
  ],
  Manager: [
    {
      name: "داشبورد",
      url: "/Manager/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "جستجو",
      url: "/Manager/search",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "منابع انسانی",
      // url: "#",
      icon: "fa fa-address-book",
      open: false,
      children: [
        {
          name: "مدیریت",
          url: "/hrm/employees",
          icon: "fa fa-gear",
          open: false,
        },
        {
          name: "گزارش",
          url: "/hrm/reports",
          icon: "fa fa-line-chart",
          open: false,
        },
        {
          name: "متقاضیان فعال",
          url: "/hrm/activeforms",
          icon: "fa fa-form",
          open: false,
        },
        {
          name: "متقاضیان رد شده",
          url: "/hrm/deactiveForms",
          icon: "fa fa-form",
          open: false,
        },
      ],
    },
    {
      name: "دبیرخانه",
      url: "/Manager/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "دفتر مرکزی",
      // url: "#",
      icon: "fa fa-list",
      open: false,
      children: [
        {
          name: "ثبت استعلام جدید",
          url: "/manager/newOrder",
          icon: "fa fa-plus",
          open: false,
        },
        {
          name: "سفارش سریع",
          url: "/manager/newFastOrder",
          icon: "fa fa-bolt",
          open: false,
        },
        {
          name: "استعلام‌های فعال",
          url: "/Manager/activeOrders",
          icon: "fa fa-envelope-open",
          open: false,
        },
        {
          name: "استعلام‌های فعال ویژه",
          url: "/Manager/activeVipOrders",
          icon: "fa fa-heart-o",
          open: false,
        },
        {
          name: "استعلام‌های آماده ارسال به کارخانه",
          url: "/Manager/orderstoproducts",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "آرشیو استعلام‌ها",
          url: "/Manager/orders",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "به تفکیک وضعیت",
          url: "#",
          icon: "fa fa-list",
          open: false,
          badge: {
            variant: "primary",
            text: "جدید",
          },
          children: [
            {
              name: "ثبت استعلام",
              url: "/Manager/ordersPerStatus/1",
              icon: "fa fa-gear",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "در انتظار بررسی فنی",
              url: "/Manager/ordersPerStatus/2",
              icon: "fa fa-gears",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "تعیین قیمت توسط مدیر عامل",
              url: "/Manager/ordersPerStatus/3",
              icon: "fa fa-dollar",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "بررسی تعیین قیمت توسط مدیر فروش",
              url: "/Manager/ordersPerStatus/4",
              icon: "fa fa-money",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "آماده برای امضا",
              url: "/Manager/ordersPerStatus/5",
              icon: "fa fa-pencil-square-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "اعلام تعیین قیمت به مشتری",
              url: "/Manager/ordersPerStatus/6",
              icon: "fa fa-bullhorn",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "در انتظار نظر مشتری",
              url: "/Manager/ordersPerStatus/7",
              icon: "fa fa-clock-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "تایید تعیین قیمت توسط مشتری",
              url: "/Manager/ordersPerStatus/8",
              icon: "fa fa-check-square-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "رد تعیین قیمت توسط مشتری",
              url: "/Manager/ordersPerStatus/9",
              icon: "fa fa-times-rectangle-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "عدم",
              url: "/Manager/ordersPerStatus/10",
              icon: "fa fa-deaf",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "آرشیو",
              url: "/Manager/ordersPerStatus/11",
              icon: "fa fa-archive",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "بازبینی تعیین قیمت",
              url: "/Manager/ordersPerStatus/12",
              icon: "fa fa-spinner",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "آماده ارسال به کارخانه",
              url: "/Manager/ordersPerStatus/13",
              icon: "fa fa-thumbs-o-up",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
            {
              name: "ارسال به کارخانه",
              url: "/Manager/ordersPerStatus/14",
              icon: "fa fa-send-o",
              open: false,
              badge: {
                variant: "success",
                text: "",
              },
            },
          ],
        },
        {
          name: "مدیریت مشتری‌ها",
          url: "/Manager/customerManagement",
          icon: "fa fa-users",
          open: false,
        },
      ],
    },
    {
      name: "کارخانه",
      // url: "#",
      icon: "fa fa-list",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "آرشیو سفارش‌ها",
          url: "/factory/ordersArchive",
          icon: "fa fa-archive",
          open: false,
        },
        // {
        //   name: "پیگیری اقلام سفارش‌ها",
        //   url: "/factory/orderItems",
        //   icon: "fa fa-check-square",
        // },
        {
          name: "اقلام در حال تولید",
          url: "/factory/productionItemsPerStatus",
          icon: "fa fa-gear",
          open: false,
        },
        {
          name: "فرآیند تولید",
          url: "/factory/productionProcess",
          icon: "fa fa-chain",
          open: false,
        },
        {
          name: "اقلام به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "مشاهده اقلام به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
          children: [
            {
              name: "بررسی اولیه",
              url: "/factory/orderItemsPerStatusId/1",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "توقف موقت تولید",
              url: "/factory/orderItemsPerStatusId/2",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله تامین مواد اولیه",
              url: "/factory/orderItemsPerStatusId/3",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله تولید",
              url: "/factory/orderItemsPerStatusId/4",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله تامین",
              url: "/factory/orderItemsPerStatusId/5",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "موجود در انبار",
              url: "/factory/orderItemsPerStatusId/6",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله پوشش کاری",
              url: "/factory/orderItemsPerStatusId/7",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "اتمام تولید",
              url: "/factory/orderItemsPerStatusId/8",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله ارسال",
              url: "/factory/orderItemsPerStatusId/9",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در مرحله بسته بندی",
              url: "/factory/orderItemsPerStatusId/10",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "لغو سفارش",
              url: "/factory/orderItemsPerStatusId/11",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "تحویل نهایی",
              url: "/factory/orderItemsPerStatusId/12",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت تولید",
              url: "/factory/orderItemsPerStatusId/13",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش گالوانیزه گرم",
              url: "/factory/orderItemsPerStatusId/14",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش تفلون",
              url: "/factory/orderItemsPerStatusId/15",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش سرامیک",
              url: "/factory/orderItemsPerStatusId/16",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش زایلون",
              url: "/factory/orderItemsPerStatusId/17",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش گالوانیزه سرد",
              url: "/factory/orderItemsPerStatusId/18",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت پوشش داک",
              url: "/factory/orderItemsPerStatusId/19",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت خدمات فورجینگ",
              url: "/factory/orderItemsPerStatusId/20",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "خرید خدمت سختکاری",
              url: "/factory/orderItemsPerStatusId/21",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در انتظار صدور نقشه فنی",
              url: "/factory/orderItemsPerStatusId/22",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در انتظار تایید نقشه فنی",
              url: "/factory/orderItemsPerStatusId/23",
              icon: "fa fa-list",
              open: false,
            },
            {
              name: "در انتظار خرید خدمت",
              url: "/factory/orderItemsPerStatusId/24",
              icon: "fa fa-list",
              open: false,
            },
          ],
        },
      ],
    },
    {
      name: "انبارداری",
      // url: "#",
      icon: "fa fa-list",
      open: false,
      children: [
        {
          name: "مدیریت انبارها",
          url: "#",
          icon: "fa fa-database",
          open: false,
          children: [
            {
              name: "لیست انبارها",
              url: "/warehouse/allWarehouses",
              icon: "fa fa-check-square",
              open: false,
            },
            {
              name: "محصولات",
              url: "/warehouse/productsWarehouses",
              icon: "fa fa-archive",
              open: false,
            },
            {
              name: "رسید و حواله‌های محصولات",
              url: "/warehouse/productsProfile",
              icon: "fa fa-search",
              open: false,
            },
            {
              name: "مواد اولیه",
              url: "/warehouse/materialsWarehouses",
              icon: "fa fa-archive",
              open: false,
            },
            {
              name: "رسید و حواله‌های مواد اولیه",
              url: "/warehouse/materialsProfile",
              icon: "fa fa-search",
              open: false,
            },
            {
              name: "ملزومات",
              url: "/warehouse/toolsWarehouses",
              icon: "fa fa-archive",
              open: false,
            },
          ],
        },
        {
          name: "مدیریت اقلام",
          url: "#",
          icon: "fa fa-archive",
          open: false,
          children: [
            {
              name: "محصولات",
              url: "/warehouse/products",
              icon: "fa fa-archive",
              open: false,
            },
            {
              name: "جستجوی محصولات",
              url: "/warehouse/productsSearch",
              icon: "fa fa-search",
              open: false,
            },
            {
              name: "جستجوی دقیق محصولات",
              url: "/warehouse/productsExactSearch",
              icon: "fa fa-search-plus",
              open: false,
            },
            {
              name: "مواد اولیه",
              url: "/warehouse/materials",
              icon: "fa fa-archive",
              open: false,
            },
            {
              name: "ملزومات",
              url: "/warehouse/tools",
              icon: "fa fa-archive",
              open: false,
            },
          ],
        },
        // {
        //   name: "مدیریت رسید و حواله",
        //   url: "#",
        //   icon: "fa fa-archive",
        //   children: [
        //     {
        //       name: "تایید نشده‌ها",
        //       url: "/warehouse/exchanges/unconfirmed",
        //       icon: "fa fa-clock-o"
        //     },
        //     {
        //       name: "آرشیو تراکنش‌ها",
        //       url: "/warehouse/exchanges/all",
        //       icon: "fa fa-check-square"
        //     }
        //   ]
        // }
      ],
    },
    {
      name: "فروشگاه",
      url: "/shop/dashboard",
      icon: "fa fa-list",
      open: false,
      // children: [
      //   {
      //     name: "مشتریان",
      //     url: "/shop/customers",
      //     icon: "fa fa-address-book",
      //     open:false,
      //   },
      //   {
      //     name: "محصولات",
      //     url: "/shop/products",
      //     icon: "fa fa-diamond",
      //     open:false,
      //   },
      //   {
      //     name: "گزارش‌ها",
      //     url: "/shop/reports",
      //     icon: "fa fa-bar-chart",
      //     open:false,
      //   },
      //   {
      //     name: "فاکتورها",
      //     url: "#",
      //     icon: "fa fa-file-text",
      //     open:false,
      //     children: [
      //       {
      //         name: "پیش فاکتورها",
      //         url: "/shop/preInvoices",
      //         icon: "fa fa-edit",
      //         open:false,
      //       },
      //       {
      //         name: "فاکتورهای خرید",
      //         url: "/shop/purchaseInvoices",
      //         icon: "fa fa-shopping-cart",
      //         open:false,
      //       },
      //       {
      //         name: "فاکتورهای فروش",
      //         url: "/shop/salesInvoices",
      //         icon: "fa fa-money",
      //         open:false,
      //       },
      //     ],
      //   },
      //   {
      //     name: "مدیریت چک‌ها",
      //     url: "/shop/chequesList",
      //     icon: "fa fa-file-text",
      //     open:false,
      //   },
      //   {
      //     name: "دریافت‌ها",
      //     url: "/shop/payments",
      //     icon: "fa fa-paypal",
      //     open:false,
      //   },
      // ],
    },
    {
      name: "تنظیمات",
      // url: "#",
      icon: "fa fa-list",
      open: false,
      open: false,
      children: [
        {
          name: "قوانین صدور استعلام",
          url: "/Manager/rules",
          icon: "fa fa-legal",
          open: false,
        },
        {
          name: "واحدهای پولی",
          url: "/Manager/currencies",
          icon: "fa fa-money",
          open: false,
        },
        {
          name: "الگوهای سازمانی",
          url: "/Manager/templates",
          icon: "fa fa-map",
          open: false,
        },
        {
          name: "تغییر رمزعبور",
          url: "/Manager/changePassword",
          icon: "fa fa-lock",
          open: false,
        },
      ],
    },
    {
      name: "گزارش‌ها",
      // url: "#",
      icon: "fa fa-line-chart",
      open: false,
      open: false,
      children: [
        {
          name: "یک نگاه",
          url: "/Manager/reports",
          icon: "fa fa-line-chart",
          open: false,
        },
        {
          name: "گزارش فروش",
          url: "/Manager/salesReports",
          icon: "fa fa-bar-chart",
          open: false,
        },
        {
          name: "گزارش اقلام",
          url: "/Manager/itemReports",
          icon: "fa fa-line-chart",
          open: false,
        },
        {
          name: "گزارش مالی اقلام",
          url: "/Manager/itemFinancialReports",
          icon: "fa fa-line-chart",
          open: false,
        },
      ],
    },
  ],
  factory: [
    {
      name: "داشبورد",
      url: "/factory/productionDashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "مشاهده اقلام به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
      children: [
        {
          name: "بررسی اولیه",
          url: "/factory/orderItemsPerStatusId/1",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "توقف موقت تولید",
          url: "/factory/orderItemsPerStatusId/2",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین مواد اولیه",
          url: "/factory/orderItemsPerStatusId/3",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تولید",
          url: "/factory/orderItemsPerStatusId/4",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین",
          url: "/factory/orderItemsPerStatusId/5",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "موجود در انبار",
          url: "/factory/orderItemsPerStatusId/6",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله پوشش کاری",
          url: "/factory/orderItemsPerStatusId/7",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "اتمام تولید",
          url: "/factory/orderItemsPerStatusId/8",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله ارسال",
          url: "/factory/orderItemsPerStatusId/9",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله بسته بندی",
          url: "/factory/orderItemsPerStatusId/10",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "لغو سفارش",
          url: "/factory/orderItemsPerStatusId/11",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "تحویل نهایی",
          url: "/factory/orderItemsPerStatusId/12",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت تولید",
          url: "/factory/orderItemsPerStatusId/13",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه گرم",
          url: "/factory/orderItemsPerStatusId/14",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش تفلون",
          url: "/factory/orderItemsPerStatusId/15",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش سرامیک",
          url: "/factory/orderItemsPerStatusId/16",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش زایلون",
          url: "/factory/orderItemsPerStatusId/17",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه سرد",
          url: "/factory/orderItemsPerStatusId/18",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش داک",
          url: "/factory/orderItemsPerStatusId/19",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت خدمات فورجینگ",
          url: "/factory/orderItemsPerStatusId/20",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت سختکاری",
          url: "/factory/orderItemsPerStatusId/21",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار صدور نقشه فنی",
          url: "/factory/orderItemsPerStatusId/22",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار تایید نقشه فنی",
          url: "/factory/orderItemsPerStatusId/23",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار خرید خدمت",
          url: "/factory/orderItemsPerStatusId/24",
          icon: "fa fa-list",
          open: false,
        },
      ],
    },
    {
      name: "آرشیو سفارش‌ها",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    // {
    //   name: "پیگیری اقلام سفارش‌ها",
    //   url: "/factory/orderItems",
    //   icon: "fa fa-check-square",
    // },
    {
      name: "اقلام سفارش‌ها به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "مدیریت انبارها",
      url: "#",
      icon: "fa fa-database",
      open: false,
      children: [
        {
          name: "لیست انبارها",
          url: "/warehouse/allWarehouses",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "محصولات",
          url: "/warehouse/productsWarehouses",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "مواد اولیه",
          url: "/warehouse/materialsWarehouses",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "ملزومات",
          url: "/warehouse/toolsWarehouses",
          icon: "fa fa-archive",
          open: false,
        },
      ],
    },
    {
      name: "مدیریت اقلام",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "محصولات",
          url: "/warehouse/products",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "جستجوی محصولات",
          url: "/warehouse/productsSearch",
          icon: "fa fa-search",
          open: false,
        },
        {
          name: "جستجوی دقیق محصولات",
          url: "/warehouse/productsExactSearch",
          icon: "fa fa-search-plus",
          open: false,
        },
        {
          name: "مواد اولیه",
          url: "/warehouse/materials",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "ملزومات",
          url: "/warehouse/tools",
          icon: "fa fa-archive",
          open: false,
        },
      ],
    },
    {
      name: "دبیرخانه",
      url: "/factory/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/factory/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  factoryTechnical: [
    {
      name: "داشبورد",
      url: "/factoryTechnical/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "مشاهده تولید",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "آرشیو سفارش‌ها",
          url: "/factory/ordersArchive",
          icon: "fa fa-archive",
          open: false,
        },
        // {
        //   name: "پیگیری اقلام سفارش‌ها",
        //   url: "/factory/orderItems",
        //   icon: "fa fa-check-square",
        // },
        {
          name: "اقلام سفارش‌ها به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
        },
      ],
    },
    {
      name: "انبار محصولات",
      url: "/warehouse/products",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/factoryTechnical/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/factoryTechnical/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  qc: [
    {
      name: "داشبورد",
      url: "/qc/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "مشاهده تولید",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "اقلام سفارش‌ها به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
        },
      ],
    },
    {
      name: "انبار محصولات",
      url: "/warehouse/products",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "انبار مواد اولیه",
      url: "/warehouse/materialsWarehouses",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/qc/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/qc/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  qa: [
    {
      name: "داشبورد",
      url: "/qa/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "مشاهده تولید",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "اقلام سفارش‌ها به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "آرشیو سفارش‌ها",
          url: "/factory/ordersArchive",
          icon: "fa fa-archive",
          open: false,
        },
      ],
    },
    {
      name: "انبار محصولات",
      url: "/warehouse/products",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "جستجوی محصولات",
      url: "/warehouse/productsSearch",
      icon: "fa fa-search",
      open: false,
    },
    {
      name: "جستجوی دقیق محصولات",
      url: "/warehouse/productsExactSearch",
      icon: "fa fa-search-plus",
      open: false,
    },
    {
      name: "مواد اولیه",
      url: "/warehouse/materials",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/qa/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/qa/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  production: [
    {
      name: "داشبورد",
      url: "/production/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "اقلام سفارش‌ها به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/production/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/production/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  delivery: [
    {
      name: "داشبورد",
      url: "/delivery/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "مشاهده اقلام به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
      children: [
        {
          name: "بررسی اولیه",
          url: "/factory/orderItemsPerStatusId/1",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "توقف موقت تولید",
          url: "/factory/orderItemsPerStatusId/2",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین مواد اولیه",
          url: "/factory/orderItemsPerStatusId/3",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تولید",
          url: "/factory/orderItemsPerStatusId/4",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین",
          url: "/factory/orderItemsPerStatusId/5",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "موجود در انبار",
          url: "/factory/orderItemsPerStatusId/6",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله پوشش کاری",
          url: "/factory/orderItemsPerStatusId/7",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "اتمام تولید",
          url: "/factory/orderItemsPerStatusId/8",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله ارسال",
          url: "/factory/orderItemsPerStatusId/9",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله بسته بندی",
          url: "/factory/orderItemsPerStatusId/10",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "لغو سفارش",
          url: "/factory/orderItemsPerStatusId/11",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "تحویل نهایی",
          url: "/factory/orderItemsPerStatusId/12",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت تولید",
          url: "/factory/orderItemsPerStatusId/13",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه گرم",
          url: "/factory/orderItemsPerStatusId/14",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش تفلون",
          url: "/factory/orderItemsPerStatusId/15",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش سرامیک",
          url: "/factory/orderItemsPerStatusId/16",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش زایلون",
          url: "/factory/orderItemsPerStatusId/17",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه سرد",
          url: "/factory/orderItemsPerStatusId/18",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش داک",
          url: "/factory/orderItemsPerStatusId/19",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت خدمات فورجینگ",
          url: "/factory/orderItemsPerStatusId/20",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت سختکاری",
          url: "/factory/orderItemsPerStatusId/21",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار صدور نقشه فنی",
          url: "/factory/orderItemsPerStatusId/22",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار تایید نقشه فنی",
          url: "/factory/orderItemsPerStatusId/23",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار خرید خدمت",
          url: "/factory/orderItemsPerStatusId/24",
          icon: "fa fa-list",
          open: false,
        },
      ],
    },
    {
      name: "آرشیو سفارش‌ها",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "اقلام سفارش‌ها به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/delivery/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/delivery/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  coldForgingSupervisor: [
    {
      name: "داشبورد",
      url: "/coldForgingSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/coldForgingSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/coldForgingSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  cuttingNutSupervisor: [
    {
      name: "داشبورد",
      url: "/cuttingNutSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/cuttingNutSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/cuttingNutSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  coatingSupervisor: [
    {
      name: "داشبورد",
      url: "/coatingSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/coatingSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/coatingSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  threadingSupervisor: [
    {
      name: "داشبورد",
      url: "/threadingSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/threadingSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/threadingSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  machiningSupervisor: [
    {
      name: "داشبورد",
      url: "/machiningSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/machiningSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/machiningSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  cncSupervisor: [
    {
      name: "داشبورد",
      url: "/cncSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/cncSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/cncSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  knittingSupervisor: [
    {
      name: "داشبورد",
      url: "/knittingSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/knittingSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/knittingSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  weldingSupervisor: [
    {
      name: "داشبورد",
      url: "/weldingSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/weldingSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/weldingSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  heatTreatmentSupervisor: [
    {
      name: "داشبورد",
      url: "/heatTreatmentSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/heatTreatmentSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/heatTreatmentSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  hotForgingSupervisor: [
    {
      name: "داشبورد",
      url: "/hotForgingSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/hotForgingSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/hotForgingSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  dichromateSupervisor: [
    {
      name: "داشبورد",
      url: "/dichromateSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/dichromateSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/dichromateSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  cuttingSupervisor: [
    {
      name: "داشبورد",
      url: "/cuttingSupervisor/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/cuttingSupervisor/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/cuttingSupervisor/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  factoryGeneral: [
    {
      name: "داشبورد",
      url: "/factoryGeneral/productionTasks",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/factoryGeneral/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/factoryGeneral/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  qcDocument: [
    {
      name: "داشبورد",
      url: "/delivery/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "مشاهده اقلام به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
      children: [
        {
          name: "بررسی اولیه",
          url: "/factory/orderItemsPerStatusId/1",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "توقف موقت تولید",
          url: "/factory/orderItemsPerStatusId/2",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین مواد اولیه",
          url: "/factory/orderItemsPerStatusId/3",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تولید",
          url: "/factory/orderItemsPerStatusId/4",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین",
          url: "/factory/orderItemsPerStatusId/5",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "موجود در انبار",
          url: "/factory/orderItemsPerStatusId/6",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله پوشش کاری",
          url: "/factory/orderItemsPerStatusId/7",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "اتمام تولید",
          url: "/factory/orderItemsPerStatusId/8",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله ارسال",
          url: "/factory/orderItemsPerStatusId/9",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله بسته بندی",
          url: "/factory/orderItemsPerStatusId/10",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "لغو سفارش",
          url: "/factory/orderItemsPerStatusId/11",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "تحویل نهایی",
          url: "/factory/orderItemsPerStatusId/12",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت تولید",
          url: "/factory/orderItemsPerStatusId/13",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه گرم",
          url: "/factory/orderItemsPerStatusId/14",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش تفلون",
          url: "/factory/orderItemsPerStatusId/15",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش سرامیک",
          url: "/factory/orderItemsPerStatusId/16",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش زایلون",
          url: "/factory/orderItemsPerStatusId/17",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه سرد",
          url: "/factory/orderItemsPerStatusId/18",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش داک",
          url: "/factory/orderItemsPerStatusId/19",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت خدمات فورجینگ",
          url: "/factory/orderItemsPerStatusId/20",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت سختکاری",
          url: "/factory/orderItemsPerStatusId/21",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار صدور نقشه فنی",
          url: "/factory/orderItemsPerStatusId/22",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار تایید نقشه فنی",
          url: "/factory/orderItemsPerStatusId/23",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار خرید خدمت",
          url: "/factory/orderItemsPerStatusId/24",
          icon: "fa fa-list",
          open: false,
        },
      ],
    },
    {
      name: "آرشیو سفارش‌ها",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "اقلام سفارش‌ها به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/delivery/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/delivery/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  qcAgent: [
    {
      name: "داشبورد",
      url: "/delivery/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "مشاهده اقلام به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
      children: [
        {
          name: "بررسی اولیه",
          url: "/factory/orderItemsPerStatusId/1",
          icon: "fa fa-list",
        },
        {
          name: "توقف موقت تولید",
          url: "/factory/orderItemsPerStatusId/2",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین مواد اولیه",
          url: "/factory/orderItemsPerStatusId/3",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تولید",
          url: "/factory/orderItemsPerStatusId/4",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین",
          url: "/factory/orderItemsPerStatusId/5",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "موجود در انبار",
          url: "/factory/orderItemsPerStatusId/6",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله پوشش کاری",
          url: "/factory/orderItemsPerStatusId/7",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "اتمام تولید",
          url: "/factory/orderItemsPerStatusId/8",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله ارسال",
          url: "/factory/orderItemsPerStatusId/9",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله بسته بندی",
          url: "/factory/orderItemsPerStatusId/10",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "لغو سفارش",
          url: "/factory/orderItemsPerStatusId/11",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "تحویل نهایی",
          url: "/factory/orderItemsPerStatusId/12",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت تولید",
          url: "/factory/orderItemsPerStatusId/13",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه گرم",
          url: "/factory/orderItemsPerStatusId/14",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش تفلون",
          url: "/factory/orderItemsPerStatusId/15",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش سرامیک",
          url: "/factory/orderItemsPerStatusId/16",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش زایلون",
          url: "/factory/orderItemsPerStatusId/17",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه سرد",
          url: "/factory/orderItemsPerStatusId/18",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش داک",
          url: "/factory/orderItemsPerStatusId/19",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت خدمات فورجینگ",
          url: "/factory/orderItemsPerStatusId/20",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت سختکاری",
          url: "/factory/orderItemsPerStatusId/21",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار صدور نقشه فنی",
          url: "/factory/orderItemsPerStatusId/22",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار تایید نقشه فنی",
          url: "/factory/orderItemsPerStatusId/23",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار خرید خدمت",
          url: "/factory/orderItemsPerStatusId/24",
          icon: "fa fa-list",
          open: false,
        },
      ],
    },
    {
      name: "آرشیو سفارش‌ها",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "اقلام سفارش‌ها به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/delivery/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/delivery/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  factoryPacking: [
    {
      name: "داشبورد",
      url: "/delivery/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "مشاهده اقلام به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
      children: [
        {
          name: "بررسی اولیه",
          url: "/factory/orderItemsPerStatusId/1",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "توقف موقت تولید",
          url: "/factory/orderItemsPerStatusId/2",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین مواد اولیه",
          url: "/factory/orderItemsPerStatusId/3",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تولید",
          url: "/factory/orderItemsPerStatusId/4",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله تامین",
          url: "/factory/orderItemsPerStatusId/5",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "موجود در انبار",
          url: "/factory/orderItemsPerStatusId/6",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله پوشش کاری",
          url: "/factory/orderItemsPerStatusId/7",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "اتمام تولید",
          url: "/factory/orderItemsPerStatusId/8",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله ارسال",
          url: "/factory/orderItemsPerStatusId/9",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در مرحله بسته بندی",
          url: "/factory/orderItemsPerStatusId/10",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "لغو سفارش",
          url: "/factory/orderItemsPerStatusId/11",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "تحویل نهایی",
          url: "/factory/orderItemsPerStatusId/12",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت تولید",
          url: "/factory/orderItemsPerStatusId/13",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه گرم",
          url: "/factory/orderItemsPerStatusId/14",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش تفلون",
          url: "/factory/orderItemsPerStatusId/15",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش سرامیک",
          url: "/factory/orderItemsPerStatusId/16",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش زایلون",
          url: "/factory/orderItemsPerStatusId/17",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش گالوانیزه سرد",
          url: "/factory/orderItemsPerStatusId/18",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت پوشش داک",
          url: "/factory/orderItemsPerStatusId/19",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت خدمات فورجینگ",
          url: "/factory/orderItemsPerStatusId/20",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "خرید خدمت سختکاری",
          url: "/factory/orderItemsPerStatusId/21",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار صدور نقشه فنی",
          url: "/factory/orderItemsPerStatusId/22",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار تایید نقشه فنی",
          url: "/factory/orderItemsPerStatusId/23",
          icon: "fa fa-list",
          open: false,
        },
        {
          name: "در انتظار خرید خدمت",
          url: "/factory/orderItemsPerStatusId/24",
          icon: "fa fa-list",
          open: false,
        },
      ],
    },
    {
      name: "آرشیو سفارش‌ها",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "اقلام سفارش‌ها به تفکیک وضعیت",
      url: "/factory/orderItemsPerStatus",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/delivery/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/delivery/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  warehouse: [
    {
      name: "داشبورد",
      url: "/warehouse/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "مدیریت انبارها",
      url: "#",
      icon: "fa fa-database",
      open: false,
      children: [
        {
          name: "لیست انبارها",
          url: "/warehouse/allWarehouses",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "محصولات",
          url: "/warehouse/productsWarehouses",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "مواد اولیه",
          url: "/warehouse/materialsWarehouses",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "ملزومات",
          url: "/warehouse/toolsWarehouses",
          icon: "fa fa-archive",
          open: false,
        },
      ],
    },
    {
      name: "مدیریت اقلام",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "محصولات",
          url: "/warehouse/products",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "جستجوی محصولات",
          url: "/warehouse/productsSearch",
          icon: "fa fa-search",
          open: false,
        },
        {
          name: "جستجوی دقیق محصولات",
          url: "/warehouse/productsExactSearch",
          icon: "fa fa-search-plus",
          open: false,
        },
        {
          name: "مواد اولیه",
          url: "/warehouse/materials",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "ملزومات",
          url: "/warehouse/tools",
          icon: "fa fa-archive",
          open: false,
        },
      ],
    },
    {
      name: "پیگیری سفارش‌ها",
      url: "/factory/orders",
      icon: "fa fa-check-square",
      open: false,
    },
    {
      name: "آرشیو سفارش‌ها",
      url: "/factory/ordersArchive",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/warehouse/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
  ],
  productsWarehouse: [
    {
      name: "داشبورد",
      url: "/productsWarehouse/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "مدیریت انبار",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "انبار محصولات",
          url: "/warehouse/productsWarehouses",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "مدیریت محصولات",
          url: "/warehouse/products",
          icon: "fa fa-archive",
          open: false,
        },
        {
          name: "جستجوی محصولات",
          url: "/warehouse/productsSearch",
          icon: "fa fa-search",
          open: false,
        },
        {
          name: "جستجوی دقیق محصولات",
          url: "/warehouse/productsExactSearch",
          icon: "fa fa-search-plus",
          open: false,
        },
      ],
    },
    {
      name: "مشاهده تولید",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "اقلام سفارش‌ها به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
        },
      ],
    },
    {
      name: "دبیرخانه",
      url: "/productsWarehouse/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/productsWarehouse/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  materialsWarehouse: [
    {
      name: "داشبورد",
      url: "/materialsWarehouse/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "انبار مواد اولیه",
      url: "/warehouse/materialsWarehouses",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "مدیریت مواد اولیه",
      url: "/warehouse/materials",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "مشاهده تولید",
      url: "#",
      icon: "fa fa-archive",
      open: false,
      children: [
        {
          name: "پیگیری سفارش‌ها",
          url: "/factory/orders",
          icon: "fa fa-check-square",
          open: false,
        },
        {
          name: "اقلام سفارش‌ها به تفکیک وضعیت",
          url: "/factory/orderItemsPerStatus",
          icon: "fa fa-check-square",
          open: false,
        },
      ],
    },
    {
      name: "دبیرخانه",
      url: "/materialsWarehouse/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
    {
      name: "تغییر رمزعبور",
      url: "/materialsWarehouse/changePassword",
      icon: "fa fa-lock",
      open: false,
    },
  ],
  toolsWarehouse: [
    {
      name: "داشبورد",
      url: "/warehouse/dashboard",
      icon: "fa fa-home",
      open: false,
    },
    {
      name: "انبار ملزومات",
      url: "/warehouse/toolsWarehouses",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "مدیریت ملزومات",
      url: "/warehouse/tools",
      icon: "fa fa-archive",
      open: false,
    },
    {
      name: "دبیرخانه",
      url: "/warehouse/secretariat/dashboard",
      icon: "fa fa-envelope",
      open: false,
    },
  ],
  shop: [
    {
      name: "مشتریان",
      url: "/shop/customers",
      icon: "fa fa-address-book",
    },
    {
      name: "محصولات",
      url: "/shop/products",
      icon: "fa fa-diamond",
    },
    {
      name: "گزارش‌ها",
      url: "/shop/reports",
      icon: "fa fa-bar-chart",
    },
    {
      name: "فاکتورها",
      url: "#",
      icon: "fa fa-file-text",
      children: [
        {
          name: "پیش فاکتورها",
          url: "/shop/preInvoices",
          icon: "fa fa-edit",
        },
        {
          name: "فاکتورهای خرید",
          url: "/shop/purchaseInvoices",
          icon: "fa fa-shopping-cart",
        },
        {
          name: "فاکتورهای فروش",
          url: "/shop/salesInvoices",
          icon: "fa fa-money",
        },
      ],
    },
    {
      name: "مدیریت چک‌ها",
      url: "/shop/chequesList",
      icon: "fa fa-file-text",
    },
    {
      name: "پرداخت‌ها",
      url: "/shop/payments",
      icon: "fa fa-paypal",
    },
    {
      name: "دبیرخانه",
      url: "/shop/secretariat/dashboard",
      icon: "fa fa-envelope",
    },
  ],
  shop: [
    {
      name: "فروشگاه",
      url: "/shop/dashboard",
      icon: "fa fa-shopping-cart",
    },
    {
      name: "دبیرخانه",
      url: "/shop/secretariat/dashboard",
      icon: "fa fa-envelope",
    },
    {
      name: "تغییر رمزعبور",
      url: "/shop/changePassword",
      icon: "fa fa-lock",
    },
  ],
  secretariat: [
    {
      name: "صفحه اصلی",
      url: "/secretariat/dashboard",
      icon: "$Home",
      open: false,
    },
    {
      name: "صندوق سازمانی",
      url: "/secretariat/internal",
      icon: "$Letters",
      open: false,
    },
    {
      name: "صندوق ورودی",
      url: "/secretariat/inbox",
      icon: "$Inbox",
      open: false,
    },
    {
      name: "صندوق خروجی",
      url: "/secretariat/outbox",
      icon: "$Outbox",
      open: false,
    },
    {
      name: "تخصیص به من",
      url: "/secretariat/assignedLetters",
      icon: "$TickUser",
      open: false,
    },
    {
      name: "در انتظار امضا",
      url: "/secretariat/waitingList",
      icon: "$EditLetter",
      open: false,
    },
    {
      name: "یادآوری پیگیری",
      url: "/secretariat/reminders",
      icon: "$Clock",
      open: false,
    },
    {
      name: "تاریخچه پیگیری‌ها",
      url: "/secretariat/reminderArchive",
      icon: "$Clock",
      open: false,
    },
    {
      name: "پیش‌نویس",
      url: "/secretariat/drafts",
      icon: "$Text",
      open: false,
    },
    {
      name: "نشان شده‌ها",
      url: "/secretariat/markedLetters",
      icon: "$Letters",
      open: false,
    },
    {
      name: "بایگانی",
      url: "/secretariat/archives",
      icon: "$Archive",
      open: false,
    },
    {
      name: "قالب‌‌های نامه",
      url: "/secretariat/lettertemplates",
      icon: "$Template",
    },
  ],
  newShop: [
    {
      name: "صفحه اصلی",
      url: "/shop/dashboard",
      icon: "$Home",
    },
    {
      name: "فاکتور جدید",
      url: "/shop/newinvoice",
      icon: "$NewInvoice",
    },
    {
      name: "پیش‌فاکتور جدید",
      url: "/shop/newproforma",
      icon: "$NewInvoice",
    },
    {
      name: "محصولات",
      url: "/shop/products",
      icon: "$Bag",
    },
    {
      name: "فاکتور فروش",
      url: "/shop/salesinvoices",
      icon: "$SalesInvoice",
    },
    {
      name: "پیش‌فاکتور",
      url: "/shop/proformaList",
      icon: "$SalesInvoice",
    },
    {
      name: "مشتریان",
      url: "/shop/customers",
      icon: "$Customer",
    },
    {
      name: "پرداخت‌ها",
      url: "/shop/paymentlist",
      icon: "$Wallet",
    },
    {
      name: "باشگاه مشتریان",
      url: "/shop/club",
      icon: "$Star",
    },
    {
      name: "گزارش‌ها",
      url: "/shop/Reports",
      icon: "$Chart2",
    },
    {
      name: "تنظیمات",
      url: "/shop/Settings",
      icon: "$Cog",
    },
  ],
};
